import { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DateRange } from "react-date-range";
import CustomCalendar from "./CustomCalendar";
import Chart from "chart.js/auto";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Loader from "../../../utils/loader/loader";
import { useDispatch, useSelector } from "react-redux";
import {
  assessmentHistory,
  assessmentHistoryNotAttempted,
  assignmentInProgress,
  futureAssignment,
  generateQuestions,
  getSubjectChapter,
} from "../../../Redux/test/test.action";
import { getResource } from "../../../Redux/resource/resource.action";
import ToastMessage from "../../../utils/toasts/toastMessage";
import { formatDate, getMaterialId } from "../../../utils/utils";
import "./test.css";
import { staticIcons } from "../../../utils/assessmentSubjectIcons";
import { FutureAssignments } from "./Future_Test/FutureAssignments";
import { analyticsReport } from "../../../Redux/analytics/analytics.action";
import { MyVerticallyCenteredModal } from "./Modals/verticalCenterModal";
import NotAttemptedAssignments from "./CAT/notAttemptedAssignments";

const TestBody = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const [historySubjectFilter, setHistorySubjectFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("all"); // "all" | "attempted" | "not_attempted"
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // const store = useSelector((state) => state);

  const {
    questionsList,
    subjectChapter,
    assignmentHistory,
    inProgressAssignment,
  } = useSelector((state) => state.TestManager || {});

  const uploadedResourceStore = subjectChapter;
  const assessmentHistoryStore = assignmentHistory?.history;
  const inProgressAssignmentStore = inProgressAssignment?.assignments;
  const futureAssignmentStore = useSelector(
    (s) => s?.TestManager?.futureAssignment,
  );
  const analyticsStore = useSelector(
    (s) => s?.AnalyticsManager?.analyticsReport?.assignments,
  );
  const notAttemptedStore = useSelector(
    (s) => s?.TestManager?.assignHistoryNotAttempted?.history, // <- confirm this path
  );

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCards, setFilteredCards] = useState([]);
  const [history, setHistory] = useState([]);
  const [historyForFilter, setHistoryForFilter] = useState([]);

  const [mergedCards, setMergedCards] = useState([]);

  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [subjectChapters, setSubjectChapters] = useState({}); //contain both subject and chapter list
  const [selectedMaterialIDs, setSelectedMaterialIDs] = useState([]);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [modalShow, setModalShow] = useState(false);
  const [totalAssignments, setTotalAssignments] = useState(0);

  const [questionData, setQuestionData] = useState([]);

  const [questionTypes, setQuestionTypes] = useState({
    mcq: { enabled: false, count: 0, label: "MCQ" },
    fill: { enabled: false, count: 0, label: "Fill in the blanks" },
    short: { enabled: false, count: 0, label: "Short Questions" },
    // long: { enabled: false, count: 0, label: "Long Questions" },
  });

  useEffect(() => {
    dispatch(getResource());
    dispatch(getSubjectChapter());
    dispatch(assessmentHistory());
    dispatch(assignmentInProgress());
    dispatch(assessmentHistoryNotAttempted());
  }, [dispatch]);

  useEffect(() => {
    dispatch(analyticsReport());
    dispatch(futureAssignment());
  }, [dispatch]);

  useEffect(() => {
    if (assessmentHistoryStore?.length > 0) {
      const mergedData = assessmentHistoryStore.map((item) => {
        const matchedIcon = staticIcons.find(
          (icon) => icon.subject?.toLowerCase() === item.subject?.toLowerCase(),
        );
        return {
          ...item,
          img: matchedIcon ? matchedIcon.img : null,
          __cardType: "attempted",
        };
      });
      setMergedCards(mergedData);
      setFilteredCards(mergedData);
    } else {
      setMergedCards([]);
      setFilteredCards([]);
    }
  }, [assessmentHistoryStore]);

  useEffect(() => {
    if (inProgressAssignmentStore?.length > 0) {
      const mergedData = inProgressAssignmentStore.map((item) => {
        const matchedIcon = staticIcons.find(
          (icon) =>
            icon.subject?.toLowerCase() === item?.subjectName?.toLowerCase(),
        );
        return {
          ...item,
          img: matchedIcon ? matchedIcon.img : null,
        };
      });
      setQuestionData(mergedData);
    }
  }, [inProgressAssignmentStore]);

  useEffect(() => {
    if (
      uploadedResourceStore &&
      Object.keys(uploadedResourceStore).length > 0
    ) {
      setSubjectChapters(uploadedResourceStore);
    }
  }, [uploadedResourceStore]);

  const [currentPage, setCurrentPage] = useState(1);
  // const [pageCount, setPageCount] = useState(0);
  const [showDateRange, setShowDateRange] = useState(false);
  const dateRangeRef = useRef(null);

  // const pageSize = 4;
  // Before:
const pageSize = 4;

// After:
const [rowsPerPage, setRowsPerPage] = useState(4);

  useEffect(() => {
    if (history?.length > 0) {
      const mergedData = history.map((item) => {
        const matchedIcon = staticIcons.find(
          (icon) => icon.subject?.toLowerCase() === item.subject?.toLowerCase(),
        );
        return { ...item, img: matchedIcon ? matchedIcon.img : null };
      });
      setFilteredCards(mergedData);
      setMergedCards(mergedData);
    } else {
      setFilteredCards([]);
      setMergedCards([]);
    }
  }, [history]);

  const handleSearchInput = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const id = setTimeout(() => {
      setDebouncedSearch(searchQuery.trim().toLowerCase());
    }, 500);
    return () => clearTimeout(id);
  }, [searchQuery]);

  const showPage = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const prevTotalRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const testData = {
      notStarted: futureAssignmentStore?.length || 0,
      inProgress: 0,
      completed: analyticsStore?.length || 0,
    };
    const { notStarted, inProgress, completed } = testData;
    const total = notStarted + inProgress + completed;
    const isEmpty = total === 0;

    // skip redundant re-render if nothing actually changed
    const signature = `${notStarted}-${inProgress}-${completed}`;
    if (prevTotalRef.current === signature) return;
    prevTotalRef.current = signature;

    setTotalAssignments(total);

    const chartData = isEmpty ? [1] : [notStarted, inProgress, completed];
    const chartColors = isEmpty
      ? ["#FFFFFF"]
      : ["#F45B69", "#F5C144", "#4CD964"];

    if (chartInstance.current) {
      chartInstance.current.data.datasets[0].data = chartData;
      chartInstance.current.data.datasets[0].backgroundColor = chartColors;
      chartInstance.current.update();
    } else {
      chartInstance.current = new Chart(chartRef.current.getContext("2d"), {
        type: "doughnut",
        data: {
          datasets: [
            {
              data: chartData,
              backgroundColor: chartColors,
              borderWidth: 0,
              borderRadius: 10,
              spacing: 4,
            },
          ],
        },
        options: {
          cutout: "72%",
          rotation: -90,
          circumference: 360,
          plugins: {
            legend: { display: false },
            tooltip: { enabled: !isEmpty },
          },
        },
      });
    }
  }, [futureAssignmentStore, analyticsStore]);

  const dateFieldOf = (item) =>
    item?.submitted_at ||
    item?.due_date ||
    item?.assigned_at ||
    item?.created_at ||
    item?.start_time ||
    null;

  const filteredCombinedCards = useMemo(() => {
    const attempted = (mergedCards || []).map((c) => ({
      ...c,
      __cardType: "attempted",
    }));
    const notAttempted = (notAttemptedStore || []).map((c) => ({
      ...c,
      __cardType: "not_attempted",
    }));

    let combined = [...notAttempted, ...attempted];

    // status filter
    if (statusFilter !== "all") {
      combined = combined.filter((c) => c.__cardType === statusFilter);
    }

    // subject filter (dedicated to history, not the generator's selectedSubject)
    if (historySubjectFilter) {
      combined = combined.filter(
        (c) => c.subject?.toLowerCase() === historySubjectFilter.toLowerCase(),
      );
    }

    // search query
    if (debouncedSearch) {
      combined = combined.filter((c) =>
        c.subject?.toLowerCase().includes(debouncedSearch),
      );
    }

    // date range — only apply once user picked a real end date
    const { startDate, endDate } = state[0] || {};
    if (startDate && endDate) {
      const start = new Date(startDate).setHours(0, 0, 0, 0);
      const end = new Date(endDate).setHours(23, 59, 59, 999);
      combined = combined.filter((c) => {
        const raw = dateFieldOf(c);
        if (!raw) return false;
        const t = new Date(raw).getTime();
        return t >= start && t <= end;
      });
    }

    return combined;
  }, [
    mergedCards,
    notAttemptedStore,
    statusFilter,
    historySubjectFilter,
    debouncedSearch,
    state,
  ]);

  // const pageCount = Math.ceil(filteredCombinedCards.length / pageSize);

  // const paginatedCards = filteredCombinedCards.slice(
  //   (currentPage - 1) * pageSize,
  //   currentPage * pageSize,
  // );
    // useEffect(() => {
  //   setCurrentPage(1);
  // }, [statusFilter, historySubjectFilter, debouncedSearch, state]);

  const pageCount = Math.ceil(filteredCombinedCards.length / rowsPerPage);

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  const paginatedCards = filteredCombinedCards.slice(startIndex, endIndex);

  useEffect(() => {
  setCurrentPage(1);
}, [statusFilter, historySubjectFilter, debouncedSearch, state, rowsPerPage]);

  const saveScrollPosition = () => {
    sessionStorage.setItem("testPageScrollY", String(window.scrollY));
  };
  useEffect(() => {
    if (paginatedCards?.length > 0) {
      const savedY = sessionStorage.getItem("testPageScrollY");
      if (savedY !== null) {
        // wait a tick so the DOM has painted the restored list
        requestAnimationFrame(() => {
          window.scrollTo({ top: Number(savedY), behavior: "auto" });
          sessionStorage.removeItem("testPageScrollY");
        });
      }
    }
  }, [paginatedCards]);

  const historySubjects = useMemo(() => {
    const all = [...(mergedCards || []), ...(notAttemptedStore || [])];
    const unique = Array.from(
      new Set(all.map((c) => c?.subject).filter(Boolean)),
    );
    return ["All", ...unique];
  }, [mergedCards, notAttemptedStore]);

  const handleViewTest = (assessmentID) => {
    saveScrollPosition();
    const viewTest = mergedCards?.find((s) => s.assignment_id === assessmentID);
    nav("/showallanswers", { state: { viewTest } });
  };

  useEffect(() => {
    let chartInstance;

    const dataThreeDoughnutChart = (
      elementId,
      labels,
      data,
      backgroundColors,
      borderColors,
    ) => {
      const canvas = document.getElementById(elementId);
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      if (chartInstance) {
        chartInstance.destroy();
      }

      chartInstance = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: backgroundColors,
              hoverBackgroundColor: backgroundColors,
              borderWidth: 10,
              borderColor: borderColors,
              hoverBorderColor: borderColors,
              cutout: "66%",
              borderRadius: 30,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
        },
      });
    };

    dataThreeDoughnutChart(
      "donutChartTest",
      ["Python", "React", "Angular"],
      [300, 150, 280],
      ["#f06b56", "#f7d16f", "#63d56d"],
      "#000000",
    );

    // Cleanup function to destroy the chart instance
    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateRangeRef.current &&
        !dateRangeRef.current.contains(event.target) &&
        event.target.id !== "datepicker"
      ) {
        setShowDateRange(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDateRange = () => {
    setShowDateRange((prev) => !prev);
  };

  const applyDateFilter = (range) => {
    const start = new Date(range.startDate).setHours(0, 0, 0, 0);
    const end = new Date(range.endDate).setHours(23, 59, 59, 999);

    const filtered = historyForFilter.filter((item) => {
      const itemDate = new Date(item.submitted_at).getTime();
      return itemDate >= start && itemDate <= end;
    });

    setHistory(filtered);
  };

  const handleSubjectChange = (event) => {
    const subject = event.target.value;
    setSelectedSubject(subject);
    setSelectedChapters([]);
    setSelectedCount(0);
  };

  const handleFilterSubject = (e) => {
    setHistorySubjectFilter(e.target.value);
  };

  useEffect(() => {
    if (selectedSubject === "") {
      setHistory(historyForFilter);
    } else {
      const filterHistory = historyForFilter?.filter(
        (s) => s.subject.toLowerCase() === selectedSubject.toLowerCase(),
      );
      setHistory(filterHistory);
    }
  }, [selectedSubject]);

  const handleChapterChange = (e, chapterName, materialID) => {
    if (e.target.checked) {
      setSelectedChapters((prev) => [...prev, chapterName]);
      setSelectedMaterialIDs((prev) => [...prev, materialID]);
    } else {
      setSelectedChapters((prev) => prev.filter((c) => c !== chapterName));
      setSelectedMaterialIDs((prev) => prev.filter((id) => id !== materialID));
    }
  };

  // toggle a question type checkbox
  const toggleQuestionType = (key) => {
    setQuestionTypes((prev) => ({
      ...prev,
      [key]: { ...prev[key], enabled: !prev[key].enabled },
    }));
  };

  // update number for a type
  const updateTypeCount = (key, value) => {
    const num = Math.max(0, Number(value) || 0);
    setQuestionTypes((prev) => ({
      ...prev,
      [key]: { ...prev[key], count: num },
    }));
  };

  const handleGenerateQuestions = async () => {
    setLoading(true);
    if (!selectedChapters || !selectedSubject) {
      setToastState({
        show: true,
        message: "Please select a subject and at least one chapter.",
        type: "error",
      });

      setLoading(false);
      return;
    }
    const { mcq, fill, short } = questionTypes;
    if (mcq.count === 0 && fill.count === 0 && short.count === 0) {
      setToastState({
        show: true,
        message: "Please select at least one question type with a count.",
        type: "error",
      });

      setLoading(false);
      return;
    }

    const payLoad = {
      material_id: selectedMaterialIDs,
      num_mcq: questionTypes.mcq.count,
      num_short: questionTypes.short.count,
      num_fill_ups: questionTypes.fill.count,
    };
    try {
      await dispatch(
        generateQuestions(payLoad, selectedSubject, selectedChapters),
      );
      setToastState({
        show: true,
        message: "Questions generated! Start your test",
        type: "success",
      });
      dispatch(assignmentInProgress());
      // update selectedCount so Start Test has value
      setSelectedSubject("");
      setSelectedChapters([]);
      setQuestionTypes({
        mcq: { enabled: false, count: 0, label: "MCQ" },
        fill: { enabled: false, count: 0, label: "Fill in the blanks" },
        short: { enabled: false, count: 0, label: "Short Questions" },
        // long: { enabled: false, count: 0, label: "Long Questions" },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleStartTest = (assignmentID) => {
    saveScrollPosition();
    const filterData = questionData?.filter(
      (s) => +s?.assignment_id === +assignmentID,
    );
    nav("/mcqtest", { state: { filterData, selectedCount } });
  };

  const handleViewNotAttempted = (card) => {
    saveScrollPosition();
    nav("/showallanswers", { state: { viewTest: card } });
  };

  const getSubjectIcon = (
    subject,
    fallbackImg = "./assets/subject-logo/free_icon.png",
  ) => {
    if (!subject) return fallbackImg;
    const matched = staticIcons.find(
      (icon) => icon.subject?.toLowerCase() === subject?.toLowerCase(),
    );
    return matched ? matched.img : fallbackImg;
  };

  //Rendering cards dynamically
  const renderCard = (data, fallback, idx) => {
    const isStatic = !data;
    const subject = data?.subject || fallback.subject;
    const chapter = data?.chapter[0] || fallback.chapter;
    const img = getSubjectIcon(subject, fallback.img);
    // const img = data?.img || fallback.img;
    const time = data?.questionsList?.total_questions;
    const assignmentID = data?.assignment_id;

    return (
      <li className="list-inline-item" key={idx}>
        <div className="a-card">
          <div className="a-card__top d-flex justify-content-between">
            <div className="left">
              <h5 className="m-0 fz24 card-title">
                {`Test Your ${subject} Knowledge`}
              </h5>
            </div>
            <div className="right right--math">
              <img src={img} alt="icon" />
            </div>
          </div>

          <div className="a-card__bottom">
            <p className="fz16 fw400 inner">
              {`Here you can get the questions related to ${chapter}. Questions can be mcqs, short answers or fill in the blanks. Try to attempt all the questions.`}
            </p>
            <div className="other-info d-flex justify-content-between align-items-center">
              {/* <div className="left d-flex align-items-center">
                <img
                  src="./assets/images/inner-pages/icons/icon-clock--blue.svg"
                  alt=""
                  className="me-2"
                />
                <span className="ff2 fw500 fz16">{time || "5"} mins</span>
              </div> */}
              <div className="right">
                <button
                  className="border-0 btn btn-solid btn-solid--dark fz16 fw500 ff2"
                  disabled={isStatic}
                  onClick={
                    isStatic ? undefined : () => handleStartTest(assignmentID)
                  }
                >
                  Start Test
                </button>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  };

  const subjects = ["All", ...Object.keys(subjectChapters)];

  return (
    <section className="p-0 code-practice code-practice--test-page">
      <div className="code-practice__assignments hide-below-768">
        <div className="flex-row align-items-center title-row">
          <h4 className="fw900 ff2 fz28 text-nowrap mb-0">Daily Assignments</h4>
          <div className="title-row__right">
            <div className="dropdown">
              <button
                className="py-0 border-0 btn btn-solid btn-solid--dark dropdown-toggle"
                type="button"
                key="testSubject"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw500 lh1 fz18">
                  {selectedSubject ? selectedSubject : "Subject"}
                </span>
                <img
                  className="dd-icon"
                  src="./assets/images/inner-pages/icons/icon-dropdown-arrow-white.svg"
                  alt=""
                />
              </button>
              <div className="mt-1 bdrs10 dropdown-menu">
                {Object.keys(subjectChapters).map((subject, index) => (
                  <li key={index}>
                    <div className="p-1 fw500 fz16 checkbox-container">
                      <input
                        id={`lang-${index + 1}`}
                        type="radio"
                        name="lang"
                        value={subject}
                        checked={selectedSubject === subject}
                        onChange={handleSubjectChange}
                      />
                      <label
                        className="text-nowrap"
                        htmlFor={`lang-${index + 1}`}
                      >
                        <b />
                        {subject}
                      </label>
                    </div>
                  </li>
                ))}
              </div>
            </div>

            <div className="dropdown">
              <button
                className="py-0 border-0 btn btn-solid btn-solid--dark dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled={!selectedSubject}
                style={
                  !selectedSubject
                    ? { opacity: 0.5, cursor: "not-allowed" }
                    : undefined
                }
              >
                {/* <span className="fw500 lh1 fz18">{"Chapters"}</span> */}
                <span className="fw500 lh1 fz18">
                  {selectedChapters.length === 0
                    ? "Chapters"
                    : selectedChapters.length === 1
                      ? selectedChapters[0]
                      : `${selectedChapters[0]} +${selectedChapters.length - 1} more`}
                </span>
                <img
                  className="dd-icon"
                  src="./assets/images/inner-pages/icons/icon-dropdown-arrow-white.svg"
                  alt=""
                />
              </button>

              <div className="mt-1 bdrs10 dropdown-menu">
                <ul
                  className="m-0 ff2 list-unstyled"
                  onClick={(e) => e.stopPropagation()}
                >
                  {selectedSubject ? (
                    subjectChapters[selectedSubject]?.map((c, index) => (
                      <li key={index}>
                        <div className="ps-0 fw500 fz18 checkbox-container">
                          <input
                            id={`ch-${index + 1}`}
                            type="checkbox"
                            name="chapter"
                            value={c.chapter}
                            checked={selectedChapters.includes(c.chapter)}
                            onChange={(e) =>
                              handleChapterChange(e, c.chapter, c.material_id)
                            }
                          />
                          <label
                            className="text-nowrap"
                            htmlFor={`ch-${index + 1}`}
                          >
                            <b />
                            {c.chapter}
                          </label>
                        </div>
                      </li>
                    ))
                  ) : (
                    <div className="p-0 fw500 fz18">
                      <b />
                      {"No data available."}
                    </div>
                  )}
                </ul>
              </div>
            </div>

            <div className="dropdown">
              <button
                className="py-0 border-0 btn btn-solid btn-solid--dark dropdown-toggle"
                type="button"
                key="testSubject"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled={selectedChapters.length === 0}
                style={
                  selectedChapters.length === 0
                    ? { opacity: 0.5, cursor: "not-allowed" }
                    : undefined
                }
              >
                <span className="fw500 lh1 fz18">
                  {Object.values(questionTypes).some((q) => q.enabled)
                    ? Object.keys(questionTypes)
                        .filter((k) => questionTypes[k].enabled)
                        .map(
                          (k) =>
                            `${questionTypes[k].label}${
                              questionTypes[k].count
                                ? ` - ${questionTypes[k].count}`
                                : ""
                            }`,
                        )
                        .join(", ")
                    : "Questions"}
                </span>
                <img
                  className="dd-icon"
                  src="./assets/images/inner-pages/icons/icon-dropdown-arrow-white.svg"
                  alt=""
                />
              </button>
              <div className="mt-1 bdrs10 dropdown-menu p-0">
                <ul className="m-0 ff2 list-unstyled">
                  {/* MCQ */}
                  <li className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center">
                      <input
                        id="qt-mcq"
                        type="checkbox"
                        checked={questionTypes.mcq.enabled}
                        onChange={() => toggleQuestionType("mcq")}
                      />
                      <label htmlFor="qt-mcq" className="ms-2 fw500 fz16">
                        MCQ
                      </label>
                    </div>
                    <div
                      style={{
                        minWidth: 90,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{ opacity: questionTypes.mcq.enabled ? 1 : 0.4 }}
                      >
                        -
                      </span>
                      <input
                        type="text"
                        min={0}
                        className="form-control fw500"
                        style={{ width: 60 }}
                        value={questionTypes.mcq.count}
                        disabled={!questionTypes.mcq.enabled}
                        onChange={(e) => updateTypeCount("mcq", e.target.value)}
                      />
                    </div>
                  </li>

                  {/* Fill in the blanks */}
                  <li className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center">
                      <input
                        id="qt-fill"
                        type="checkbox"
                        checked={questionTypes.fill.enabled}
                        onChange={() => toggleQuestionType("fill")}
                      />
                      <label htmlFor="qt-fib" className="ms-2 fw500 fz16">
                        Fill in the blanks
                      </label>
                    </div>
                    <div
                      style={{
                        minWidth: 90,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{
                          opacity: questionTypes.fill.enabled ? 1 : 0.4,
                        }}
                      >
                        -
                      </span>
                      <input
                        type="text"
                        min={0}
                        className="form-control fw500"
                        style={{ width: 60 }}
                        value={questionTypes.fill.count}
                        disabled={!questionTypes.fill.enabled}
                        onChange={(e) =>
                          updateTypeCount("fill", e.target.value)
                        }
                      />
                    </div>
                  </li>

                  {/* Short Questions */}
                  <li className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center">
                      <input
                        id="qt-short"
                        type="checkbox"
                        checked={questionTypes.short.enabled}
                        onChange={() => toggleQuestionType("short")}
                      />
                      <label htmlFor="qt-short" className="ms-2 fw500 fz16">
                        Short Questions
                      </label>
                    </div>
                    <div
                      style={{
                        minWidth: 90,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{
                          opacity: questionTypes.short.enabled ? 1 : 0.4,
                        }}
                      >
                        -
                      </span>
                      <input
                        type="text"
                        min={0}
                        className="form-control fw500"
                        style={{ width: 60 }}
                        value={questionTypes.short.count}
                        disabled={!questionTypes.short.enabled}
                        onChange={(e) =>
                          updateTypeCount("short", e.target.value)
                        }
                      />
                    </div>
                  </li>

                  {/* Long Questions */}
                  {/* <li className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center">
                      <input
                        id="qt-long"
                        type="checkbox"
                        checked={questionTypes.long.enabled}
                        onChange={() => toggleQuestionType("long")}
                      />
                      <label htmlFor="qt-long" className="ms-2 fw500 fz16">
                        Long Questions
                      </label>
                    </div>
                    <div
                      style={{
                        minWidth: 90,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{
                          opacity: questionTypes.long.enabled ? 1 : 0.4,
                        }}
                      >
                        -
                      </span>
                      <input
                        type="number"
                        min={0}
                        className="form-control fw500"
                        style={{ width: 60 }}
                        value={questionTypes.long.count}
                        disabled={!questionTypes.long.enabled}
                        onChange={(e) =>
                          updateTypeCount("long", e.target.value)
                        }
                      />
                    </div>
                  </li> */}

                  <li className="mt-2">
                    <div className="d-flex justify-content-between">
                      <button
                        // className="btn btn-outline"
                        className="btn btn-solid btn-solid--dark fw500 lh1 fz18"
                        onClick={() =>
                          setQuestionTypes({
                            mcq: { enabled: false, count: 0, label: "MCQ" },
                            fill: {
                              enabled: false,
                              count: 0,
                              label: "Fill in the blanks",
                            },
                            short: {
                              enabled: false,
                              count: 0,
                              label: "Short Questions",
                            },
                            // long: {
                            //   enabled: false,
                            //   count: 0,
                            //   label: "Long Questions",
                            // },
                          })
                        }
                      >
                        Reset
                      </button>
                      <button
                        className="btn btn-solid btn-solid--dark fw500 lh1 fz18"
                        onClick={handleGenerateQuestions}
                      >
                        Generate
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="bdrs40 data-empty-state">
          <h2 className="fz24 fw700 ff2">
            Oh Snap! No assignment uploaded yet!
          </h2>
          <img className="empty-state-img"
            src="./assets/images/inner-pages/test-empty-illustration.svg"
            alt="empty state"
          />
          <p className="grayText">
            Looks like you haven’t uploaded an assignment yet. To stay on track and keep your progress visible of your assignments click on upload assignment.
          </p>
          <Button
            className="fz18 btn btn-solid btn-solid--red border-0"
            onClick={() => setModalShow(true)}
          >
            Upload Assignments
          </Button>
        </div> */}
        <div className="data-available">
          <ul className="list-inline my-0 assignment-cards hide-below-768">
            {renderCard(
              questionData?.[0],
              {
                subject: "Subject",
                chapter: "selected subject",
                img: "./assets/subject-logo/free_icon.png",
              },
              0,
            )}

            {renderCard(
              questionData?.[1],
              {
                subject: "Subject",
                chapter: "selected subject",
                img: "./assets/subject-logo/subject-icon-random.png",
              },
              1,
            )}
          </ul>

          <FutureAssignments />

          <div
            className="main-block-assignments hide-below-768"
            id="main-block-assignments"
          >
            <div className="title-row">
              <h4 className="fw900 ff2 fz28">Assignment History</h4>
              <div className="title-row__right">
                <div
                  className="form-group form-group--search"
                  style={{ position: "relative" }}
                >
                  <input
                    autoComplete="off"
                    type="search"
                    id="searchCards"
                    className="border-0 fz18 fw500 form-control"
                    role="search"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearchInput}
                    style={{
                      padding: "12px 40px 12px 40px",
                      height: "48px",
                    }}
                  />

                  <img
                    src="./assets/images/inner-pages/icons/icon-search.svg"
                    alt="search"
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "18px",
                      pointerEvents: "none",
                    }}
                  />
                </div>

                <div style={{ position: "relative" }}>
                  <button
                    className="p-0 border-0 btn btn-round btn-round--navy bg-dark calendar-white-input"
                    id="datepicker"
                    onClick={toggleDateRange}
                  >
                    <img
                      src="./assets/images/inner-pages/icons/icon-calendar-white.svg"
                      alt=""
                    />
                  </button>

                  {showDateRange && (
                    <div
                      ref={dateRangeRef}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: "0",
                        zIndex: 10,
                        background: "white",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        padding: "10px",
                      }}
                    >
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => setState([item.selection])}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                      />

                      {/* APPLY + RESET BUTTONS */}
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <button
                          className="btn btn-primary"
                          onClick={() => setShowDateRange(false)}
                        >
                          Apply
                        </button>

                        <button
                          className="btn btn-secondary"
                          onClick={(e) => {
                            e.preventDefault();
                            const defaultRange = {
                              startDate: new Date(),
                              endDate: null,
                              key: "selection",
                            };
                            setState([defaultRange]);
                            setShowDateRange(false);
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="dropdown">
                  <button
                    className="py-0 border-0 btn btn-solid btn-solid--dark dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="fw500 lh1 fz18">
                      {statusFilter === "all"
                        ? "All Status"
                        : statusFilter === "attempted"
                          ? "Attempted"
                          : "Not Attempted"}
                    </span>
                    <img
                      className="dd-icon"
                      src="./assets/images/inner-pages/icons/icon-dropdown-arrow-white.svg"
                      alt=""
                    />
                  </button>
                  <div className="mt-1 bdrs10 dropdown-menu">
                    {[
                      { label: "All Status", value: "all" },
                      { label: "Attempted", value: "attempted" },
                      { label: "Not Attempted", value: "not_attempted" },
                    ].map((opt, index) => (
                      <ul key={index} className="m-0 ff2 list-unstyled">
                        <li>
                          <div className="p-1 fw500 fz16 checkbox-container">
                            <input
                              id={`status-${index}`}
                              type="radio"
                              name="status-filter"
                              checked={statusFilter === opt.value}
                              onChange={() => setStatusFilter(opt.value)}
                            />
                            <label htmlFor={`status-${index}`}>
                              <b />
                              {opt.label}
                            </label>
                          </div>
                        </li>
                      </ul>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <ul className="list-inline mb-0 assignment-cards assignment-cards--main">
              {paginatedCards?.length > 0 ? (
                paginatedCards.map((card) =>
                  card.__cardType === "not_attempted" ? (
                    <NotAttemptedAssignments
                      key={`na-${card.assignment_id}`}
                      data={[card]}
                      onView={handleViewNotAttempted}
                    />
                  ) : (
                    <li key={card.id || card.assignment_id}>
                      <div className="a-card a-card--main">
                        <div className="a-card__top">
                          <div className="left d-flex justify-content-between">
                            <h5 className="m-0 fz22 searchable card-title">
                              {`Test Your ${card?.subject || ""} Knowledge`}
                            </h5>
                            <span
                              className="status-badge status-badge--attempted"
                              style={{
                                position: "relative",
                                padding: "3px 10px",
                                borderRadius: 12,
                                fontSize: 10,
                                fontWeight: 600,
                                color: "#fff",
                                backgroundColor: "#4CD964",
                              }}
                            >
                              Attempted
                            </span>
                          </div>

                          <div className="right right--math">
                            <img src={card?.img} alt="NA" />
                          </div>
                        </div>
                        <div className="a-card__bottom">
                          <p className="fz16 fw400 inner">
                            Here you can get the questions related to{" "}
                            {card?.chapter}. Questions can be mcqs, short
                            answers or fill in the blanks. Try to attempt all
                            the questions.
                          </p>
                          <div className="other-info">
                            <div className="other-info__inner">
                              {/* <div className="left">
                                <img
                                  src="./assets/images/inner-pages/icons/icon-clock--blue.svg"
                                  alt=""
                                />
                                <span className="ff2 fw500 fz16">
                                  {card?.total_questions} mins
                                </span>
                              </div> */}
                              {
                                card?.duration_minutes !== undefined &&
                                    <div className="left">
                                <img
                                  src="./assets/images/inner-pages/icons/icon-clock--blue.svg"
                                  alt=""
                                />
                                <span className="ff2 fw500 fz16">
                                  {card?.duration_minutes} mins
                                </span>
                              </div>
                              }
                              
                              <div className="sep" />
                              <div className="middle">
                                <img
                                  src="./assets/images/inner-pages/icons/icon-calendar-blue.svg"
                                  alt=""
                                />
                                <span className="ff2 fw500 fz16">
                                  {formatDate(card?.submitted_at)}
                                </span>
                              </div>
                            </div>
                            <div className="right">
                              <button
                                className="border-0 btn btn-solid btn-solid--dark fz16 fw500 ff2"
                                onClick={() =>
                                  handleViewTest(card?.assignment_id)
                                }
                              >
                                View
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  ),
                )
              ) : (
                <li className="w-100" style={{ listStyle: "none" }}>
                  <div
                    className="bdrs20"
                    style={{
                      marginLeft: "50%",
                      marginTop: "20%",
                      padding: "40px 20px",
                      textAlign: "center",
                      backgroundColor: "#f8f9fa",
                      width: "100%",
                    }}
                  >
                    <h5 className="fz20 fw700 ff2 mb-2">No data available</h5>
                    <p className="fz14 fw400 grayText mb-0">
                      No assignment history found. Once you complete an
                      assessment, it will show up here.
                    </p>
                  </div>
                </li>
              )}
            </ul>

            <Loader show={loading} />
            <ToastMessage
              show={toastState.show}
              onClose={() =>
                setToastState({ show: false, message: "", type: "" })
              }
              message={toastState.message}
              type={toastState.type}
            />

         {paginatedCards?.length > 0 && (
  <div className="pagination">
    <div className="page-info">
      Showing {startIndex + 1}–{Math.min(endIndex, filteredCombinedCards?.length)} of{" "}
      {filteredCombinedCards?.length}
    </div>
    <div className="page-controls">
      <button
        disabled={currentPage === 1}
        onClick={() => setCurrentPage(1)}
      >
        |‹
      </button>
      <button
        disabled={currentPage === 1}
        onClick={() => setCurrentPage((p) => p - 1)}
      >
        ‹
      </button>
      <span className="current-page">
        Page {currentPage} of {pageCount}
      </span>
      <button
        disabled={currentPage === pageCount}
        onClick={() => setCurrentPage((p) => p + 1)}
      >
        ›
      </button>
      <button
        disabled={currentPage === pageCount}
        onClick={() => setCurrentPage(pageCount)}
      >
        ›|
      </button>
    </div>
    <div className="page-size">
      Rows:{" "}
      <select
        value={rowsPerPage}
        onChange={(e) => setRowsPerPage(Number(e.target.value))}
      >
        <option value={4}>4</option>
        <option value={8}>8</option>
        {/* <option value={30}>30</option>
        <option value={40}>40</option>
        <option value={50}>50</option> */}
      </select>
    </div>
  </div>
)}
          </div>
        </div>
      </div>
      <div className="code-practice__all-track">
        {/* <div className="ff-poppins bdrs30 custom-calendar custom-calendar--blue">
          <CustomCalendar />

          Level bar
          <div className="bdrs20 level-bar">
            <div className="level-bar__left">
              <img
                src="./assets/images/inner-pages/icons/icon-badge--orange.svg"
                alt=""
              />
            </div>
            <div className="level-bar__right">
              <div className="text">
                <span className="fw700 ff2 fz16">Level 10</span>
                <span className="fw400 fz12">65% complete</span>
              </div>
              <div className="progress-block">
                <span className="" />
              </div>
            </div>
          </div>
        </div> */}

        {/* Performance stats */}
        <div className="bdrs30 widget-block widget-block--dark p-3">
          <h4 className="fw700 ff2 fz28 mb-1">Total Assignments</h4>
          {/* <p className="fw400 ff2 fz16">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p> */}
          <div className="ff2 chart-block">
            <div className="bdrs20 chart-block__legends">
              <ul className="m-0 list-inline">
                <li>
                  <div className="pair">
                    <div className="dot dot--dark01">
                      <span></span>
                    </div>
                    <div className="fw700 fz16 l-text">Not Started</div>
                  </div>
                </li>
                <li>
                  <div className="pair">
                    <div className="dot dot--dark02">
                      <span></span>
                    </div>
                    <div className="fw700 fz16 l-text">In Progress</div>
                  </div>
                </li>
                <li>
                  <div className="pair">
                    <div className="dot dot--dark03">
                      <span></span>
                    </div>
                    <div className="fw700 fz16 l-text">Completed</div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="chart-block__donut">
              <div className="inner-text">
                <div className="inner-text">
                  <h4 className="fw700 fz34">
                    {totalAssignments ? totalAssignments : 0}
                  </h4>
                </div>
                {/* <p className="mb-0 fz12 fw400">Active Tests</p> */}
              </div>
              <div className="chart-container">
                {/* <canvas id="donutChartTest"></canvas> */}
                <canvas ref={chartRef}></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={modalShow}
        selectedSubject={selectedSubject}
        subjectChapters={subjectChapters}
        handleSubjectChange={handleSubjectChange}
        toggleDateRange={toggleDateRange}
        showDateRange={showDateRange}
        dateRangeRef={dateRangeRef}
        setState={setState}
        state={state}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default TestBody;
